import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';

const CompanyShareholders = React.lazy(() => import('./index'));
const CompanyShareholderTable = React.lazy(() => import('./companyShareholderTable'));
const CompanyShareholder = React.lazy(() => import('./companyShareholder'));
const CompanyShareholderDetail = React.lazy(() => import('./companyShareholderDetail'));

export const useCompanyShareholderRoutes = () => {

    return (
        <Route path="companyShareholders" element={<Suspense fallback={<div>منتظر باشید...</div>}><CompanyShareholders /></Suspense>} >
            <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><CompanyShareholderTable/></Suspense> } />
            <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><CompanyShareholder/></Suspense> } >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><CompanyShareholderDetail/></Suspense> } />
            </Route>
        </Route>
    )
}